<template>
  <div class="cancel-complete-pane">
    <sub-header-section :pageTitle="$tc('CancelPage.sectionTitle')" />

    <complete-pane
      :hasActionButton="false"
      :pageTitle="$tc('CancelPage.CompletePage.title')"
      :message="$tc('CancelPage.CompletePage.message')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import CompletePane from '@/components/pc/MyPage/CompletePane/CompletePane.vue'

/**
 * 退会完了ページ
 */
export default defineComponent({
  name: 'CancelCompletePage',
  components: {
    SubHeaderSection,
    CompletePane,
  },
})
</script>

<style lang="scss" scoped>
.cancel-complete-pane {
  &__header {
    position: sticky;
    top: 0;
  }
}
</style>
